/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Image from '@atlaskit/image';
import bannerDark from '../../assets/plans-standard-dark.svg';
import bannerLight from '../../assets/plans-standard-light.svg';

export const FeatureGateLogo = ({
	colorMode,
	alt,
}: {
	colorMode: string | undefined;
	alt: string;
}): React.JSX.Element => <Image src={colorMode === 'dark' ? bannerDark : bannerLight} alt={alt} />;
